export const SocialMediaWrapper =
  'flex flex-row pt-1 w-full justify-center md:w-fit md:justify-start'
export const SocialMediaIcons = 'tracking-0.6 leading-20'
export const SocialMediaIconsWrapper = 'flex-auto fill-white'
export const SocialMediaYTIconsWrapper =
  'flex-auto fill-white pl-1 pt-1 md:pt-0'
